var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#F05123;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#F05123;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.2,8.2c0-3.5,2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3s-2.8,6.3-6.3,6.3S7.2,11.7,7.2,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.7,15.9c1.2,0.5,2.1,1.1,2.8,1.7c1.1,0.9,1.7,2.3,1.7,3.7v1.8c0,1.1-0.9,2-2,2H3.8c-1.1,0-2-0.9-2-2 v-1.8c0-1.4,0.6-2.8,1.7-3.7c1.8-1.6,5.1-3.2,10-3.2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSelectIcon);
export default __webpack_public_path__ + "static/media/profileSelectIcon.c748e9256eaaf4e947701cb31f3fa1da.svg";
export { ForwardRef as ReactComponent };